function isOnScreen(s) {
    if (s.length != 0) {
        var e = jQuery(window),
            t = e.scrollTop(),
            o = e.height(),
            l = t + o,
            n = jQuery(s),
            i = n.offset().top,
            r = n.height(),
            a = i + r;
        return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
    }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".gk-card-product__price-color-variants .color-swatch").forEach((swatch) => {
    swatch.addEventListener("click", function () {
      let newImage = this.getAttribute("data-image");
      let productItem = this.closest(".gk-card-product");
      let mainImage = productItem.querySelector(".gk-card-product__image-main");

      if (newImage) {
        mainImage.src = newImage;
      }
    });
  });

  isOnScreen($(".non-sticky-atc-button").eq(0))
        ? $(".sticky-atc-button").fadeOut(100)
        : $(".sticky-atc-button").fadeIn(100),
        $(window).on("scroll", function () {
            isOnScreen($(".non-sticky-atc-button .product__info-container product-form").eq(0))
                ? $(".sticky-atc-button").fadeOut(10)
                : $(".sticky-atc-button").fadeIn(10);
        })

	
	// Accordion Start
	document.addEventListener("click", function (e) {
    const accordionHeader = e.target.closest(".js-gk-accordion-item-header");

    if (!accordionHeader) return;

    const accoItem = accordionHeader.closest(".js-gk-accordion-item");
    const accoWrapper = accordionHeader.closest(".js-gk-accordion");

    if (!accoItem || !accoWrapper) return;

    const accoItems = accoWrapper.querySelectorAll(".js-gk-accordion-item");
    const isAlreadyActive = accoItem.classList.contains("is--active");

    // Remove all active states
    accoItems.forEach(item => item.classList.remove("is--active"));

    // Toggle current one if it wasn't already active
    if (!isAlreadyActive) {
      accoItem.classList.add("is--active");

      setTimeout(() => {
        accordionHeader.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        if (window.scrollY !== accordionHeader.offsetTop) {
          window.scrollTo({
            top: accordionHeader.offsetTop,
            behavior: "smooth"
          });
        }
      }, 100);
    }
  });

	// Accordion End
});

document.querySelectorAll('.tab').forEach((tab) => {
  tab.addEventListener('click', function () {
    let section = this.closest('.tab-section');
    let tabs = section.querySelectorAll('.tab');
    let contents = section.querySelectorAll('.tab-content');
    let targetId = this.getAttribute('data-target');

    tabs.forEach((t) => t.classList.remove('active'));
    contents.forEach((c) => c.classList.remove('active'));

    this.classList.add('active');
    section.querySelector(`#${targetId}`).classList.add('active');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const dropdownBtn = document.querySelector('.gk-get-the-look__dropdown-btn');
  const dropdownList = document.querySelector('.gk-get-the-look__dropdown-list');
  const items = document.querySelectorAll('.gk-get-the-look__dropdown-items li');

  if(dropdownBtn) {
    dropdownBtn.textContent = items[0] ? items[0].textContent : 'Select Category'; 
  
    dropdownBtn.addEventListener('click', function() {
      dropdownList.classList.toggle('active');
    });
  }
  

  items.forEach(item => {
    item.addEventListener('click', function() {
      dropdownBtn.textContent = item.textContent;
      items.forEach(i => i.classList.remove('selected'));
      item.classList.add('selected');
      let section = this.closest('.dropdown-section');
      let contents = section.querySelectorAll('.dropdown-content');
      let targetId = this.dataset.value;
      contents.forEach((c) => c.classList.remove('active'));
      this.classList.add('active');
      section.querySelector(`#gtl-${targetId}`).classList.add('active');
      const sliders = section.querySelector(`#gtl-${targetId} .js-gk-get-the-look-slider`);
      var slideCount = $(sliders).children().length;
      if ($(sliders).length > 0 && $(sliders).hasClass('slick-initialized')) {
      $(sliders).slick('unslick');
      $(sliders).slick({
				dots: false,
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: false,				
				responsive: [				
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 3,							
              		centerMode: slideCount > 1,
				      		centerPadding: '30px',
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							centerMode: slideCount > 1,
							centerPadding: '25px'
						}
					}
				]
			});
      } else {
        console.warn("Slick is not initialized on this element.");
      }
      dropdownList.classList.remove('active');
    });
  });
});

const radioButtons = document.querySelectorAll('.mobile-facets__radio');
const sortByDropdown = document.getElementById('SortBy');
  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('change', (e) => {
      const selectedValue = e.target.value;
      sortByDropdown.value = selectedValue;
      const event = new Event('change');
      sortByDropdown.dispatchEvent(event);
    });
  });

(function() {
var parent = document.querySelector(".range-slider");
if (!parent) return;

var rangeS = parent.querySelectorAll("input[type=range]");
var numberS = parent.querySelectorAll("input[type=number]");

rangeS.forEach(function(el) {
el.oninput = function() {
var slide1 = parseFloat(rangeS[0].value),
    slide2 = parseFloat(rangeS[1].value);

if (slide1 > slide2) {
  [slide1, slide2] = [slide2, slide1];
}

numberS[0].value = slide1;
numberS[1].value = slide2;
}
});

numberS.forEach(function(el) {
el.oninput = function() {
var number1 = parseFloat(numberS[0].value),
    number2 = parseFloat(numberS[1].value);

if (number1 > number2) {
  var tmp = number1;
  numberS[0].value = number2;
  numberS[1].value = tmp;
}

rangeS[0].value = number1;
rangeS[1].value = number2;
}
});
})();

function getUrlParameter(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
window.addEventListener('load', function() {
    var minPrice = getUrlParameter('filter.v.price.gte');
    var maxPrice = getUrlParameter('filter.v.price.lte');
    if (minPrice) {
      document.getElementById('range-min').value = minPrice;
      document.getElementById('min-price').value = minPrice;
    }

    if (maxPrice) {
      document.getElementById('range-max').value = maxPrice;
      document.getElementById('max-price').value = maxPrice;
    }
    updateProgress();
  });
  function updateProgress() {
    if(document.getElementById('range-min')){
      var min = parseFloat(document.getElementById('range-min').value);
    }
    if(document.getElementById('range-max')){
      var max = parseFloat(document.getElementById('range-max').value);
    }
    var progressBar = document.querySelector('.progress');
    if (progressBar) {
      var rangeWidth = (max - min) / (document.getElementById('range-max').max - document.getElementById('range-min').min) * 100;
      progressBar.style.width = rangeWidth + '%';
    }
  }

function initializeTabs() {
  $('.js-gk-tabs').each(function (index, item) {
    var $mainContainer = $(this);
    var $menuContainer = $(this).find('.js-gk-tabs-nav-item');
    var $content = $(this).find('.js-gk-tabs-content-item');
    $content.hide();
    $menuContainer.each(function (idx, ele) {
      $(this).attr('data-target', idx);
    });
    $($menuContainer[0]).addClass('current');
    $($content[0]).show();
    $(this).find('.js-gk-tabs-nav-item').click(function (event) {
      event.preventDefault();
      $(this).closest('.js-gk-tabs').find('.current').removeClass('current');
      $(this).addClass('current');
      $(this).closest('.js-gk-tabs').find('.js-gk-tabs-content:first > .js-gk-tabs-content-item').hide();
      $(this).closest('.js-gk-tabs').find('.js-gk-tabs-content:first > .js-gk-tabs-content-item').eq(parseInt($(this).attr('data-target'))).show();

      let parentElement = $(this).closest('.js-gk-tabs').find('.js-gk-tabs-content:first > .js-gk-tabs-content-item').eq(parseInt($(this).attr('data-target')));
      if ($(".js-gk-accordian-item.show", parentElement).length === 0) {
        parentElement.find(".js-gk-accordian .js-gk-accordian-item:first .js-gk-accordian-item-head").click();
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {

initializeTabs();  // Initialize tabs

// Initialize accordion only if accordion exists
if ($('.js-gk-accordian').length > 0) {
  var faqAccordion = new Accordion({
    element: ".js-gk-accordian",
    activeTab: 0  // Set the first tab as active
  });
}
});

function reinitEmptyCartSlider() {
  if($('.js-cart-drawer__collection-product-slider').length > 0) {
    $('.js-cart-drawer__collection-product-slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      centerPadding: '25px'
    });
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
}

function CartRecommendationSlider() {
  if($('#CartDrawer-Item-1').length === 0) {
    return;
  }
  var this_last_product_id = $('#CartDrawer-Item-1').attr("data-product-id"); 
  fetch(`/recommendations/products.json?product_id=`+this_last_product_id)
  .then(response => response.json())
  .then(data => {
    let container = document.querySelector("#filled-cart-recommendations-product");
    $("#filled-cart-recommendations-product").html('');
    var locale_iso_code = $('#current_iso_code').val();
    if(locale_iso_code == "nl") {
      locale_iso_code = '';
    } else {
      locale_iso_code = '/'+locale_iso_code;
    }
    if (data.products.length > 0) {
      var totalReccProducts = Math.min(data.products.length, 4);
      var loadedReccProducts = 0;
      data.products.slice(0, totalReccProducts).forEach((product) => { // Limit to 4 products
        $.get(locale_iso_code+'/products/' + product.handle + '?view=gk-product-card', function(response) {
          let productHTML = `
            <div class="cart-drawer__collection-product__item">
              ${response} <!-- Fetched product card HTML -->
            </div>
          `;
          container.insertAdjacentHTML("beforeend", productHTML);
          loadedReccProducts++;
          if (loadedReccProducts === totalReccProducts) {
            initRecommendationSlider(); // Call only when the last product loads
          }
        });
      });
    } else {
      document.getElementById("recommended-product-container").style.display = "none";
    }
  })
  .catch(error => console.error("Error fetching recommendations:", error));
}

function initRecommendationSlider() {
  $('.js-cart-drawer__filled-product-slider').slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    centerPadding: '25px'
  });
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

$(document).ready(function () {
  CartRecommendationSlider();
  reinitEmptyCartSlider();
});

function pdpRecommendationsLoaded() {
  $('.js-gk-recc-product-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '70px',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          centerPadding: '30px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerPadding: '26px',
        },
      },
    ],
  });
}

window.pdpMixMatchSlider = function() {

  if ($('.js-gk-mix-match-slider').length > 0) {
    if ($('.js-gk-mix-match-slider').hasClass("slick-initialized")) {
      $('.js-gk-mix-match-slider').slick('unslick');
    }
    $('.js-gk-mix-match-slider').slick({
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '30px',
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '26px',
          },
        },
      ],
    });
  } else {
    console.log("Slider element not found.");
  }
};


// VARIANT JS

window.initializeDrawer = function(chooseSizeLinkId, drawerId, closeButtonClass, overlayId) {
  let chooseSizeLink = document.querySelector(chooseSizeLinkId);
  let drawer = document.querySelector(drawerId);
  let closeButton = document.querySelector(closeButtonClass);
  let overlay = document.querySelector(overlayId);
  if (chooseSizeLink && drawer && closeButton && overlay) {
    chooseSizeLink.addEventListener("click", function(event) {
      event.preventDefault(); 
      drawer.classList.add('active');  
      document.body.classList.add('no-scroll'); 
    });

    closeButton.addEventListener("click", function() {
      drawer.classList.remove('active');  
      document.body.classList.remove('no-scroll');  
    });

    overlay.addEventListener("click", function() {
      drawer.classList.remove('active');  
      document.body.classList.remove('no-scroll'); 
    });
  } else {
    console.warn("One or more elements are missing, ensure valid IDs or classes are provided.");
  }
  const selectedSize = document.querySelector('#drawer-size .div__content .choose-size .product-form__input input[type="radio"]:checked');
  const chooseSizeText = document.querySelector("#choose-size-link .choose_size_text");  
  const selecteSizeText = document.querySelector("#choose-size-link .selected_size_text");
  const chooseSizeTextSticky = document.querySelector("#choose-size-link-sticky .choose_size_text");
  const selecteSizeTextSticky = document.querySelector("#choose-size-link-sticky .selected_size_text");
  let isdisabled = selectedSize?.classList.contains("disabled");
  if (selectedSize?.value != '') {
      if(chooseSizeText) chooseSizeText.style.display = "none";
      if(chooseSizeTextSticky) chooseSizeTextSticky.style.display = "none";
      if(selecteSizeText) selecteSizeText.innerText = selectedSize?.value;
      if(chooseSizeTextSticky) selecteSizeTextSticky.innerText = selectedSize?.value;
      if (isdisabled) {
        if(selecteSizeText) selecteSizeText.style.textDecoration = "line-through";
        if(selecteSizeTextSticky) selecteSizeTextSticky.style.textDecoration = "line-through";
      }else{
        if(selecteSizeText) selecteSizeText.style.textDecoration = "none";
        if(selecteSizeTextSticky) selecteSizeTextSticky.style.textDecoration = "none";
      }
      if(selecteSizeText) selecteSizeText.style.display = "block";
      if(selecteSizeTextSticky) selecteSizeTextSticky.style.display = "block";
  } else {
      chooseSizeText.style.display = "block";
      if(selecteSizeText) selecteSizeText.style.display = "none";
      chooseSizeTextSticky.style.display = "flex";
      if(selecteSizeTextSticky) selecteSizeTextSticky.style.display = "none";
  }
};
initializeDrawer("#choose-size-link", "#drawer-size", ".size-close", "#drawer-size #CartDrawer-Overlay");
initializeDrawer("#choose-size-link-sticky", ".drawer-size-custom", ".size-close", ".drawer-size-custom .CartDrawer-Overlay-custom");
initializeDrawer("#size_guide-link", "#drawer-sizeguide", "#size-closeguide", "#drawer-sizeguide #CartDrawer-Overlay");
window.selectSizeByOptionValueId = function(optionValueId) {
  let productWrapper = document.querySelector(".product");
  if (productWrapper) {
    let productInfo = productWrapper.querySelector(".product__info-wrapper");
    if (productInfo) {
      let variantSelect = productInfo.querySelector("variant-selects");
      if (variantSelect) {
        let sizeSelect = variantSelect.querySelector(".choose-size .hidden-size fieldset");
        const hiddenRadioButtons = sizeSelect.querySelectorAll("input[type='radio']");
        hiddenRadioButtons.forEach(function(hiddenRadioButton) {
          if (hiddenRadioButton.getAttribute("data-option-value-id") === optionValueId) {
            window.buttonAttribute = hiddenRadioButton.getAttribute("data-option-value-id");
            hiddenRadioButton.checked = true;
            const changeEvent = new Event('change', { bubbles: true, cancelable: true });
            hiddenRadioButton.dispatchEvent(changeEvent);
          }
        });
      }
    }
  }
};
const radioButtonscustom1 = document.querySelectorAll(".div__content input[type='radio']");
radioButtonscustom1.forEach(function(radioButton) {
  radioButton.addEventListener("change", function(event) {

    if (this.checked) {
      const optionValueId = this.getAttribute("data-option-value-id");
      window.selectSizeByOptionValueId(optionValueId);
    }
    const selectedSize = document.querySelector('#drawer-size .div__content .choose-size .product-form__input input[type="radio"]:checked');
    const chooseSizeText = document.querySelector("#choose-size-link .choose_size_text");
    const selecteSizeText = document.querySelector("#choose-size-link .selected_size_text");
    let isdisabled = selectedSize.classList.contains("disabled");
  
    if (selectedSize.value != '') {
        chooseSizeText.style.display = "none";
        selecteSizeText.innerText = selectedSize.value;
        if (isdisabled) {
          selecteSizeText.style.textDecoration = "line-through";
        }else{
  
          selecteSizeText.style.textDecoration = "none";
        }
        selecteSizeText.style.display = "block";
    } else {
        
        chooseSizeText.style.display = "block";
        selecteSizeText.style.display = "none";
    }
  });
});
window.updateVariantMedia = function(changedvar) {
    const productVariantImages = JSON.parse(document.getElementById('productvariantImages').textContent);
    const getsingleVariant = productVariantImages[0].variantImages.find(variant => {
        let variantTitle = variant.variant_title.toLowerCase().trim();
        variantTitle = variantTitle.replace(/ /g, '_');
        variantTitle = variantTitle.replace(/_\/_/g, '/');
        return variantTitle.includes(changedvar);  
    });

    const matchingVariants = productVariantImages[0].variantImages.filter(variant => {
        let variantTitle = variant.variant_title.toLowerCase().trim();
        variantTitle = variantTitle.replace(/ /g, '_');
        variantTitle = variantTitle.replace(/_\/_/g, '/');
        return variantTitle.includes(changedvar);
    });
    const unavailableVariants = matchingVariants
      .filter(variant => variant.variant_available === "false")
      .map(variant => variant.variant_size.trim().replace(/\s*\|\|\s*/g, '||').replace(/ /g, '_').replace(/_\/_/g, '/').toLowerCase());
    const radioInputs = document.querySelectorAll('input[type="radio"]');
    radioInputs.forEach((input) => {
        const inputValue = input.value.trim().replace(/\s*\|\|\s*/g, '||').replace(/ /g, '_').replace(/_\/_/g, '/').toLowerCase();  
    const cleanedVariants = unavailableVariants.map(variant => {
        return variant.replace(/(\|\|)/g, ' || ');
    });
    const isMatch = cleanedVariants.some(variant => variant.includes(inputValue));
    const labelElement = input.nextElementSibling;  
    if (isMatch) {
      if (labelElement) {
        labelElement.style.textDecoration = "line-through";
        labelElement.style.color = "gray";  
        if(labelElement.querySelector(".notify_me_button")){
          labelElement.querySelector(".notify_me_button").style.display = "block";
        }
      }
    } else {
      if (labelElement) {
        labelElement.style.textDecoration = "none";
        if(labelElement.querySelector(".notify_me_button")){
          labelElement.querySelector(".notify_me_button").style.display = "none";
        }
      }
    }

});
    if (getsingleVariant) {
        const productMediaList = document.querySelector("ul.product__media-list");
        const productMediaModal = document.querySelector(".product-media-modal__content");

        let newMediaItem = '';
        let newMediaItemmodal = '';

        let fileGet = '' ;
        if(getsingleVariant.files.length > 0){
          fileGet = getsingleVariant.files;
        }else{
          fileGet = getsingleVariant.prdfiles;
        }
        fileGet.forEach((file, index) => {
            if (file.file) {
                var isPng = file.file.includes('png');
                var imgClass = isPng ? 'gk-pdp-gallery-image gk-pdp-gallery-image-padding' : 'gk-pdp-gallery-image';
                 newMediaItemmodal += `
                    <img class="global-media-settings global-media-settings--no-shadow" srcset="${file.file}?width=550 550w, ${file.file} 622w" sizes="(min-width: 750px) calc(100vw - 22rem), 1100px" src="${file.file}" alt="Product Image" loading="lazy" width="1100" height="1651" data-media-id="${file.id}">
                `;
                newMediaItem += `
                    <li id="Slide-template--${index}" class="product__media-item grid__item slider__slide scroll-trigger animate--fade-in" data-media-id="template--${index}">
                        <div class="product-media-container here media-type-image media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 0.6666666666666666; --preview-ratio: 1;">
                            <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-${window.sectionId}">
                                <span class="product__media-icon motion-reduce quick-add-hidden product__media-icon--lightbox" aria-hidden="true">
                                    <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 19 19"><path fill="currentColor" fill-rule="evenodd" d="M4.667 7.94a.5.5 0 0 1 .499-.501l5.534-.014a.5.5 0 1 1 .002 1l-5.534.014a.5.5 0 0 1-.5-.5" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M7.926 4.665a.5.5 0 0 1 .501.498l.014 5.534a.5.5 0 1 1-1 .003l-.014-5.534a.5.5 0 0 1 .499-.501" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M12.832 3.03a6.931 6.931 0 1 0-9.802 9.802 6.931 6.931 0 0 0 9.802-9.802M2.323 2.323a7.931 7.931 0 0 1 11.296 11.136l4.628 4.628a.5.5 0 0 1-.707.707l-4.662-4.662A7.932 7.932 0 0 1 2.323 2.323" clip-rule="evenodd"></path></svg></span>
                                </span>
                                <div class="loading__spinner hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                                        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                                    </svg>
                                </div>
                                <div class="product__media media media--transparent">
                                    <img src="${file.file}" alt="Product Image" width="1946" height="2919" loading="lazy" class="${imgClass}">
                                </div>
                                <button class="product__media-toggle quick-add-hidden product__media-zoom-lightbox" type="button" aria-haspopup="dialog" data-media-id="${index}">
                                    <span class="visually-hidden">
                                        Open media in modal
                                    </span>
                                </button>
                            </modal-opener>
                        </div>
                    </li>`;
            }
            if (file.video) {
                  newMediaItemmodal += `
                    <deferred-media class="deferred-media media global-media-settings global-media-settings--no-shadow" style="padding-top: min(calc(100vh - 12rem), 56.33802816901409%)" data-media-id="${file.video.id}">
                        <button id="Deferred-Poster-Modal-${file.video.id}" class="deferred-media__poster" type="button">
                            <span class="deferred-media__poster-button motion-reduce">
                                <span class="svg-wrapper">
                                    <svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="Polygon 2" d="M30 18L-1.63133e-06 35.3205L-1.17124e-07 0.67949L30 18Z" fill="white"></path>
                                    </svg>
                                </span>
                            </span>
                            <img srcset="${file.video.poster_image}?width=288 288w, ${file.video.poster_image}?width=576 576w, ${file.video.poster_image}?width=550 550w, ${file.video.poster_image}?width=1100 1100w" src="${file.video.poster_image}" sizes="(min-width: 1200px) calc((1200px - 10rem) / 2), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="576" height="324.0" alt="">
                        </button>
                        <template>
                            <video playsinline="playsinline" controls="controls" autoplay="autoplay" preload="none" muted="muted" poster="${file.video.poster_image}">
                                <source src="${file.video.file_url}" type="video/mp4">
                                <img src="${file.video.poster_image}" alt="Video Poster">
                            </video>
                        </template>
                    </deferred-media>
                `;
                newMediaItem += `
                    <li id="Slide-template--${index}-video" class="product__media-item grid__item slider__slide product__media-item--full scroll-trigger animate--fade-in" data-media-id="template--${index}-video">
                        <div class="product-media-container here media-type-video media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 1.775; --preview-ratio: 1;">
                            <modal-opener class="product__modal-opener product__modal-opener--video" data-modal="#ProductModal-${window.sectionId}">
                                <span class="product__media-icon motion-reduce quick-add-hidden" aria-hidden="true">
                                    <span class="svg-wrapper"><svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="Polygon 2" d="M30 18L-1.63133e-06 35.3205L-1.17124e-07 0.67949L30 18Z" fill="white"></path>
                                    </svg></span>
                                </span>
                                <div class="loading__spinner hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                                        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                                    </svg>
                                </div>
                                <div class="product__media media media--transparent">
                                    <img src="${file.video.poster_image}" alt="Video Poster" width="1946" height="1095" loading="lazy">
                                </div>
                                <button class="product__media-toggle quick-add-hidden product__media-zoom-lightbox" type="button" aria-haspopup="dialog" data-media-id="${index}">
                                    <span class="visually-hidden">
                                        Open media in modal
                                    </span>
                                </button>
                            </modal-opener>
                            <deferred-media class="deferred-media media media--transparent" data-media-id="${index}">
                                <button id="Deferred-Poster-Modal-${index}" class="deferred-media__poster" type="button">
                                    <span class="deferred-media__poster-button motion-reduce">
                                        <span class="visually-hidden">Play video</span>
                                        <span class="svg-wrapper">
                                            <svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path id="Polygon 2" d="M30 18L-1.63133e-06 35.3205L-1.17124e-07 0.67949L30 18Z" fill="white"></path>
                                            </svg>
                                        </span>
                                    </span>
                                    <img src="${file.video.poster_image}" alt="Video Poster" width="1946" height="1095" loading="lazy">
                                </button>
                                <template>
                                    <video playsinline="playsinline" controls="controls" autoplay="autoplay" preload="none" muted="muted" poster="${file.video.poster_image}">
                                        <source src="${file.video.file_url}" type="video/mp4">
                                        <img src="${file.video.poster_image}" alt="Video Poster">
                                    </video>
                                </template>
                            </deferred-media>
                        </div>
                    </li>`;
            }
        });
        productMediaList.innerHTML = newMediaItem;
        productMediaModal.innerHTML = newMediaItemmodal;
        document.querySelector('#drawer-size').classList.remove('active');
        document.body.classList.remove('no-scroll');
    }
};

// product feature drawer


let productFeatureLink = document.querySelectorAll(".product_feature--link");

productFeatureLink.forEach((prdbutton) => {
    prdbutton.addEventListener("click", function(e) {
        e.preventDefault();  
        let drawerSelector = `#drawer-feature-${prdbutton.id}`;  
        let overlaySelector = `#drawer-feature-${prdbutton.id} #CartDrawer-Overlay`; 

        let closeButtonSelector = `#drawer-feature-${prdbutton.id} .feature-close`;  

        initializeDrawerFeature(prdbutton, drawerSelector, closeButtonSelector, overlaySelector);
    });
});
function initializeDrawerFeature(prdbutton, drawerSelector, closeButtonSelector, overlaySelector) {
    let drawer = document.querySelector(drawerSelector);
    let overlay = document.querySelector(overlaySelector);
    document.querySelector("body").classList.add("feature_active"); 
    if (drawer) {
        drawer.classList.add("active");  
    }
    if (overlay) {
        overlay.classList.add("active");  
    }
    let closeButton = document.querySelector(closeButtonSelector);
    if (closeButton) {
        closeButton.addEventListener("click", function() {
            drawer.classList.remove("active");
            overlay.classList.remove("active");
            document.querySelector("body").classList.remove("feature_active"); 
        });
    }
    if (overlay) {
        overlay.addEventListener("click", function() {
            drawer.classList.remove("active");
            overlay.classList.remove("active");
            document.querySelector("body").classList.remove("feature_active"); 
        });
    }
}
const showMoreLink = document.querySelector('.show-more-options');
  if (showMoreLink) {
    showMoreLink.addEventListener('click', function (event) {
      event.preventDefault();
      const hiddenSwatches = document.querySelectorAll('.custom-swatch-option.hidden');
      hiddenSwatches.forEach(function (swatch) {
        swatch.classList.remove('hidden');
      });
      showMoreLink.style.display = 'none';
      const showLessLink = document.createElement('a');
      showLessLink.href = '#';
      showLessLink.classList.add('show-less-options');
      showLessLink.textContent = `${window.showless}`;
      if (!document.querySelector('.show-less-options')) {
        console.log("insideshow-less-options")
        showMoreLink.parentElement.appendChild(showLessLink);
      }
      showLessLink.addEventListener('click', function (event) {
        event.preventDefault();
        const visibleSwatches = document.querySelectorAll('.custom-swatch-option');
        visibleSwatches.forEach(function (swatch, index) {
          if (index >= 7) {
            swatch.classList.add('hidden');
          }
        });
        showMoreLink.style.display = 'inline-block';
        showLessLink.remove();
      });
    });
  }
document.addEventListener('DOMContentLoaded', function () {
  const hiddenOptions = document.querySelectorAll('.custom-swatch-option.hidden');
  hiddenOptions.forEach(option => {
    const input = option.querySelector('input[type="radio"]');
    if (input && input.checked) {
      const showMoreLink = document.querySelector('.show-more-options');
      if (showMoreLink) {
        showMoreLink.click();
      }
    }
  });
  const observer = new MutationObserver(function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const restockContainer = document.getElementById('restock-rocket-inline-container');
        if (restockContainer) {
          restockContainer.style.display = 'block';
          observer.disconnect();
          break;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (window.innerWidth <= 767) { document.querySelector(".gk-product__stky-atc-right .product-form__buttons button").removeAttribute('disabled'); }
  document.querySelector(".gk-product__stky-atc-right product-form form button")?.addEventListener("click", function (event) {
    
          event.preventDefault(); 
          if (window.innerWidth <= 767) {
              setTimeout(function () {
                  const productInfoContainer = document.querySelector('.product__info-container');
                  if (productInfoContainer) {
                      productInfoContainer.scrollIntoView({
                          behavior: 'smooth', 
                          block: 'start'  
                      });
                  } else {
                      console.error("Product Info container not found");
                  }
              }, 500); 
          }else{
            const targetForm = document.querySelector(".product__info-container .product-form form");
            if (targetForm) {
                document.querySelector(".gk-product__stky-atc-right product-form form button .loading__spinner").classList.remove("hidden");
                const submitButton = targetForm.querySelector("button[type='submit']");
                if (submitButton) {
                    submitButton.dispatchEvent(new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    }));
                } else {
                    console.error("Submit button not found inside the form");
                }
            } else {
                console.error("Target form not found");
            }
          }

          setTimeout(function() {
            const errorMessage = document.querySelector('.product-form__error-message');
            const productInfoContainer = document.querySelector('.product__info-container');

            if (errorMessage) {
                errorMessage.scrollIntoView({
                    behavior: 'smooth',  
                    block: 'center',   
                });
                productInfoContainer.classList.add('error-active');
            } else {
                productInfoContainer.classList.remove('error-active');
            }
          }, 2000); 
      });
window.hideUnavailableVariants = function() {
  // Get the selected radio button value (currently checked)
  let valueLoad = document.querySelector(".product__info-container variant-selects fieldset input[type='radio']:checked");
  if (!valueLoad) return; // If no radio button is selected, exit the function

  valueLoad = valueLoad.value; // Get the value of the checked radio
  const transformedvalueLoad = valueLoad
    .toLowerCase()
    .replace(/\s*\/\s*/g, "/")
    .replace(/ /g, "_")
    .trim();

  // Get the product data from the JSON
  const productData = JSON.parse(document.getElementById("productJsonProductPage").textContent);

  // Collect all before/after slash parts from all variants
  const validMatches = new Set();

  productData.variants.forEach(variant => {
          // Access the variant options safely
      const option1 = variant.option1 || "";
      const option2 = variant.option2 || "";
      const option3 = variant.option3 || "";

      // Check if any option contains a "/"
      const hasSlash = [option1, option2, option3].some(opt => opt && opt.includes("/"));
      let transformedTitle;
      if(hasSlash){
      // ✅ Correct way to access options
      const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      transformedTitle = options
      .map(opt => opt.toLowerCase().replace(/ /g, "_"))  // lowercase and replace spaces for each option
      .join("|")                                         // join with pipe and no spaces
      .trim();
      }else{

        const variantTitle = variant.title;
        transformedTitle = variantTitle
          .toLowerCase()
          .replace(/\s*\/\s*/g, "/")
          .replace(/ /g, "_")
          .trim();
      }
      let beforeSlash, afterSlash;

    if (hasSlash) {
      [beforeSlash, afterSlash] = transformedTitle.split("|");
    } else {
      [beforeSlash, afterSlash] = transformedTitle.split("/");
    }

    if (beforeSlash === transformedvalueLoad || afterSlash === transformedvalueLoad) {
      validMatches.add(beforeSlash);
      validMatches.add(afterSlash);
    }
  });

  // Loop through all radio buttons and hide/show based on validMatches
  const radioButtonss = document.querySelectorAll("#drawer-size .choose-size .product-form__input input[type='radio']");
  
  radioButtonss.forEach(radio => {
    let hasradioslash = radio.value.includes("/");
      let transformedRadioValue;

 if(hasradioslash){
    transformedRadioValue = radio.value
      .toLowerCase()
      .replace(/ /g, "_")
      .trim();
 }else {
     transformedRadioValue = radio.value
      .toLowerCase()
      .replace(/\s*\/\s*/g, "/")
      .replace(/ /g, "_")
      .trim();
 }
    let radioBefore, radioAfter;
    if (hasradioslash) {
      [radioBefore, radioAfter] = transformedRadioValue.split("|");
    } else {
      [radioBefore, radioAfter] = transformedRadioValue.split("/");
    }
    const isMatch = validMatches.has(radioBefore) || validMatches.has(radioAfter);
    const associatedLabel = radio.closest(".product-form__input").querySelector(`label[for="${radio.id}"]`);

    if (associatedLabel) {
      if (isMatch) {
        associatedLabel.classList.remove("hidden");
      } else {
        associatedLabel.classList.add("hidden");
      }
    }
  });


  const variantMetafields = JSON.parse(document.getElementById("check_notify_me").textContent);
  const normalizedMetafields = {};
  Object.keys(variantMetafields).forEach(originalKey => {
    const transformedKey = originalKey
      .toLowerCase()
      .replace(/\s*\/\s*/g, "/")
      .replace(/ /g, "_")
      .trim();

    normalizedMetafields[transformedKey] = variantMetafields[originalKey];
  });
  document.querySelectorAll(".choose-size").forEach((chooseSizeBlock) => {
  const inputs = chooseSizeBlock.querySelectorAll('input[type="radio"]');
  let firstAvailableRadio = null;

  inputs.forEach((input, index) => {
    const variantAvail = input.getAttribute("variantavail");
    const value = input.value.trim();
    const isFirst = index === 0;
    const isValueBlank = value === "";

    // Skip the first radio if its value is blank
    if (isFirst && isValueBlank) return;

    // Determine if the radio is available
    const isAvailable = variantAvail && variantAvail.trim().toLowerCase() !== "false";
    const associatedLabel = input.closest(".product-form__input").querySelector(`label[for="${input.id}"]`);
    const isHidden = associatedLabel?.classList.contains('hidden');

    // Select the first available radio
    if (isAvailable && !isHidden && !firstAvailableRadio) {
      firstAvailableRadio = input;
    }
    // Handle "Notify Me" button visibility
    const notifyBtn = input.closest(".product-form__input").querySelector("span.notify_me_button");
    if (notifyBtn) {
      const variantTitle = value || "";
      const normalizedTitle = variantTitle
        .toLowerCase()
        .replace(/\s*\/\s*/g, "/")
        .replace(/ /g, "_")
        .trim();
      // const matchedKey = Object.keys(normalizedMetafields).find(key => key.includes(transformedRadioValue));
      // if (matchedKey) {
      //   const data = normalizedMetafields[matchedKey];
      //   const isUnavailable = data.var_avail === "false";
      //   const hasRestockDate = data.restock_date && data.restock_date.trim() !== "";
      //   if (isUnavailable && hasRestockDate) {
      //     notifyBtn.classList.remove("hide_notify--unavailable");
      //     notifyBtn.classList.add("notify_me", "yes");
      //     notifyBtn.style.display = "block";
      //   } else {
      //     notifyBtn.classList.add("hide_notify--unavailable");
      //     notifyBtn.classList.remove("notify_me", "yes");
      //     notifyBtn.style.display = "none";
      //   }
      // }
    }
  });
//  const params = new URLSearchParams(window.location.search);
//   if (params.has('variant')|| window.paramsglobal.has('variant')) {
//   // Check the first available radio if none is checked
//   if (firstAvailableRadio && !firstAvailableRadio?.checked) {
//     console.log("inside")
//     firstAvailableRadio.checked = true;
//     firstAvailableRadio.dispatchEvent(new Event('click', { bubbles: true }));
//     firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
//   }
// }
});
        
const intervalTime = 500; 

if (this._intervalId) {
  clearInterval(this._intervalId);
}

this._intervalId = setInterval(() => {
  const restockContainer = document.querySelector('#restock-rocket-inline-container');
  if (!(restockContainer instanceof Element)) return;

  const style = window.getComputedStyle(restockContainer);
  if (style.display !== 'none') {
    const formButton = document.querySelector("#form-Button");
    if (!formButton) return;

    const formButtonText = formButton.textContent.trim();

    const buttonText = document.querySelector(".gk-product__stky-atc-right .product_atc_var .gk-btn__text");
    const buttonWrapper = document.querySelector(".gk-product__stky-atc-right .product_atc_var");
  

    if (buttonText && buttonText.textContent !== formButtonText) {
    
      buttonText.textContent = formButtonText;
      document.querySelector(".custom_price").innerHTML = '';
      document.querySelector(".gk-product__stky-atc-right .custom_price").innerHTML = '';
    }

    if (buttonWrapper) {
      buttonWrapper.classList.add("notify-state");
      buttonWrapper.removeAttribute("disabled");

      if (!buttonWrapper._hasClickHandler) {
        buttonWrapper.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        });
        buttonWrapper._hasClickHandler = true;
      }
    }
  }
}, intervalTime);   



}
window.hideUnavailableVariants();
});


document.addEventListener('DOMContentLoaded', function () {
const productFormButtons = document.querySelector(".product__info-container .product-form__buttons");
const submitButton = productFormButtons?.querySelector("button.select_button ");
if (submitButton && submitButton.disabled) {
  const preText = document.querySelector(".gk-product__pre-text");
  if (preText) {
    preText.style.display = "none"; // ✅ Correct way (no !important)
  }
}

// const preTextElement = document.querySelector(".gk-product__pre-text");

// if (preTextElement && getComputedStyle(preTextElement).display !== "none") {
//   const formButton = document.querySelector("#form-Button");
//   const formButtonText = formButton ? formButton.textContent.trim() : "Notify me";

//   const buttonText = document.querySelector(".gk-product__stky-atc-right .product_atc_var .gk-btn__text");
//   const buttonWrapper = document.querySelector(".gk-product__stky-atc-right .product_atc_var");

//   if (buttonText) {
//     buttonText.textContent = formButtonText;
//   }

//   if (buttonWrapper) {
//     buttonWrapper.classList.add("notify-state");

//     buttonWrapper.removeAttribute("disabled");
//     const notifyButton = buttonWrapper.querySelector("button");

//     if (buttonWrapper) {
//       buttonWrapper.addEventListener("click", function () {
//         window.scrollTo({
//           top: 0,
//           behavior: "smooth"
//         });
//       });
      
//     }
//   }
// } 


// const targetNode = document.body;

// const observer = new MutationObserver((mutationsList, observer) => {
//   const formButton = document.querySelector("#form-Button");
//   if (formButton) {
//     const formButtonText = formButton.textContent.trim();

//     const buttonText = document.querySelector(".gk-product__stky-atc-right .product_atc_var .gk-btn__text");
//     const buttonWrapper = document.querySelector(".gk-product__stky-atc-right .product_atc_var");

//     if (buttonText) {
//       buttonText.textContent = formButtonText;
//     }

//     if (buttonWrapper) {
//     buttonWrapper.classList.add("notify-state");

//     buttonWrapper.removeAttribute("disabled");
//     const notifyButton = buttonWrapper.querySelector("button");

//     if (buttonWrapper) {
//       buttonWrapper.addEventListener("click", function () {
//         window.scrollTo({
//           top: 0,
//           behavior: "smooth"
//         });
//       });
      
//     }
//     }

//     // Stop observing once found
//     observer.disconnect();
//   }
// });

// observer.observe(targetNode, {
//   childList: true,
//   subtree: true
// });

});

const observer = new MutationObserver(() => {
  const shouldHide = document.querySelector('.hide_stoq_form, .hide_stoq_form-tag');
  const restockContainer = document.querySelector('#restock-rocket-inline-container');

  if (restockContainer) {
    if (shouldHide) {
      if (restockContainer.style.display !== 'none') {
        restockContainer.style.display = 'none';
        console.log('Hiding #restock-rocket-inline-container due to hide class');
      }
    } else {
      if (restockContainer.style.display === 'none') {
        restockContainer.style.display = '';
        console.log('Showing #restock-rocket-inline-container');
      }
    }
  }
});

// Start observing the document body
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true, // also listen for attribute/class changes
  attributeFilter: ['class']
});



const intervalTime = 500; // check every 500ms (adjust if needed)

if (this._intervalId) {
  clearInterval(this._intervalId);
}

this._intervalId = setInterval(() => {
  const restockContainer = document.querySelector('#restock-rocket-inline-container');
  if (!(restockContainer instanceof Element)) return;

  const style = window.getComputedStyle(restockContainer);
  if (style.display !== 'none') {
    const formButton = document.querySelector("#form-Button");
    if (!formButton) return;

    const formButtonText = formButton.textContent.trim();

    const buttonText = document.querySelector(".gk-product__stky-atc-right .product_atc_var .gk-btn__text");
    const buttonWrapper = document.querySelector(".gk-product__stky-atc-right .product_atc_var");

    if (buttonText && buttonText.textContent !== formButtonText) {
    
      buttonText.textContent = formButtonText;
      document.querySelector(".custom_price").innerHTML = '';
      document.querySelector(".gk-product__stky-atc-right .custom_price").innerHTML = '';
    }

    if (buttonWrapper) {
      buttonWrapper.classList.add("notify-state");
      buttonWrapper.removeAttribute("disabled");

      if (!buttonWrapper._hasClickHandler) {
        buttonWrapper.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        });
        buttonWrapper._hasClickHandler = true;
      }
    }
  }
}, intervalTime);


// function CartRecommendationSlider() {
//   if($('#CartDrawer-Item-1').length === 0) {
//     return;
//   }
//   var this_last_product_id = $('#CartDrawer-Item-1').attr("data-product-id"); 
//   fetch(`/recommendations/products.json?product_id=`+this_last_product_id)
//   .then(response => response.json())
//   .then(data => {
//     let container = document.querySelector("#filled-cart-recommendations-product");
//     $("#filled-cart-recommendations-product").html('');
//     var locale_iso_code = $('#current_iso_code').val();
//     if(locale_iso_code == "nl") {
//       locale_iso_code = '';
//     } else {
//       locale_iso_code = '/'+locale_iso_code;
//     }
//     if (data.products.length > 0) {
//       var totalReccProducts = Math.min(data.products.length, 4);
//       var loadedReccProducts = 0;
//       data.products.slice(0, totalReccProducts).forEach((product) => { // Limit to 4 products
//         $.get(locale_iso_code+'/products/' + product.handle + '?view=gk-product-card', function(response) {
//           let productHTML = `
//             <div class="cart-drawer__collection-product__item">
//               ${response} <!-- Fetched product card HTML -->
//             </div>
//           `;
//           container.insertAdjacentHTML("beforeend", productHTML);
//           loadedReccProducts++;
//           if (loadedReccProducts === totalReccProducts) {
//             initRecommendationSlider(); // Call only when the last product loads
//           }
//         });
//       });
//     } else {
//       document.getElementById("recommended-product-container").style.display = "none";
//     }
//   })
//   .catch(error => console.error("Error fetching recommendations:", error));
// }

// function initRecommendationSlider() {
//   $('.js-cart-drawer__filled-product-slider').slick({
//     dots: false,
//     infinite: false,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: false,
//     centerMode: false,
//     centerPadding: '25px'
//   });
//   document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
// }



function waitForSwatAndAddListener() {
  if (window._swat && _swat.evtLayer) {
    _swat.evtLayer.addEventListener('sw:addedtocart', listener);
  } else {
    // Retry after a short delay until _swat is ready
    setTimeout(waitForSwatAndAddListener, 100);
  }
}

waitForSwatAndAddListener();

let listener = function(e) { 
  var data = e.detail.d.productData;	
  console.log("YAY! Added the product to cart", data);

  fetch(window.location.pathname + `?sections=cart-drawer,cart-icon-bubble`)
    .then((res) => res.json())
    .then((sections) => {
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
        cartDrawerEl.classList.remove('is-empty');
        cartDrawerEl.renderContents({ sections });
        CartRecommendationSlider();
      } else {
        console.error('CartDrawer component not found or renderContents() missing');
      }
    })
    .catch(err => {
      console.error('Failed to update cart drawer:', err);
    });
};


window.disableChooseSizeLink = function() {
    const link = document.getElementById('choose-size-link');
    link.classList.add('disabled');
    link.addEventListener('click', window.preventClick);
    const links = document.getElementById('choose-size-link-sticky');
    links.classList.add('disabled');
    links.addEventListener('click', window.preventClick);
}

window.enableChooseSizeLink = function() {
    const link = document.getElementById('choose-size-link');
    link.classList.remove('disabled');
    link.removeEventListener('click', window.preventClick);
    const links = document.getElementById('choose-size-link-sticky');
    links.classList.remove('disabled');
    links.removeEventListener('click', window.preventClick);
}

window.preventClick = function(event) {
    event.preventDefault();
}


document.addEventListener("click", function (e) {
  if (e.target.matches(".product-media-modal__toggle")) {
    console.log("inside toggle click");
    const modal = e.target.closest("product-modal");
    if (modal) {
      modal.removeAttribute("open");
    }
  }
});

/** Logo Resize issue **/
function setRoundedLogoWidth() {
  const vw = window.innerWidth;
  const width = Math.round(vw * 0.07); // 7vw rounded
  document.documentElement.style.setProperty('--rounded-logo-width', `${width}px`);
}

setRoundedLogoWidth();
window.addEventListener('resize', setRoundedLogoWidth);